import { Helmet } from 'react-helmet';
// Constants
import { CompanyName } from '../../utils/Constants';

export const HelmetItem = ({
  PageName,
  desc,
  keywords,
  additionalMeta = [],
  structuredData = null, // New prop for structured data
}) => {
  const pageTitle = PageName && PageName !== 'Home' && PageName !== '/' ? `${PageName} - ${CompanyName}` : CompanyName;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={desc} />
      {/* Keywords */}
      {keywords && <meta name="keywords" content={keywords} />}
      {/* Additional meta tags */}
      {additionalMeta.map((meta, index) => (
        <meta key={index} {...meta} />
      ))}
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      )}
    </Helmet>
  );
};
